import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import CustomerProfile from '@app/features/billing/CustomerProfile/CustomerProfile';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

// const Shifts = lazy(() => import('@pages/Shifts').then((m) => ({ default: m.Shifts })));

// Route Component
const CustomerProfilePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('customer-profile-page-title')}>
        <CustomerProfile />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  CustomerProfilePage,
};
